/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minor_Plain_Bear_FetchInputs */

const en_minor_plain_bear_fetch = /** @type {(inputs: Minor_Plain_Bear_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NPS chart`)
};

const de_minor_plain_bear_fetch = /** @type {(inputs: Minor_Plain_Bear_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NPS-Diagramm`)
};

/**
* | output |
* | --- |
* | "NPS chart" |
*
* @param {Minor_Plain_Bear_FetchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const minor_plain_bear_fetch = /** @type {((inputs?: Minor_Plain_Bear_FetchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minor_Plain_Bear_FetchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minor_plain_bear_fetch(inputs)
	return de_minor_plain_bear_fetch(inputs)
});